import * as React from 'react'
import { pipe } from 'fp-ts/lib/pipeable'
import * as O from 'fp-ts/lib/Option'

import { ProjectGrantDraftApp, GeneralGrantDraftApp } from '../../../domain'
import { Org } from '@espoon-voltti/nuora-domain/applicants'
import { GrantPeriod } from '@espoon-voltti/nuora-domain/grants'

import { GeneralGrantAppForm } from './general-grant'
import { ProjectGrantAppForm } from './project-grant'

interface AppFormProps {
  app: ProjectGrantDraftApp | GeneralGrantDraftApp
  org: Org
  grantPeriod: GrantPeriod
  onChange: (app: ProjectGrantDraftApp | GeneralGrantDraftApp) => void
  onClose: () => void
  onDelete: () => void
  onSubmit: (app: ProjectGrantDraftApp | GeneralGrantDraftApp) => void
}
export const AppForm: React.FC<AppFormProps> = (p) => {
  return pipe(
    p.app,
    maybeProjectGrantApp,
    O.map((x) => <ProjectGrantAppForm key={x.id} {...p} app={x} />),
    O.getOrElse(() =>
      pipe(
        p.app,
        maybeGeneralGrantApp,
        O.map((x) => <GeneralGrantAppForm key={x.id} {...p} app={x} />),
        O.toNullable
      )
    )
  )
}

const isProjectGrantApp = (
  x: ProjectGrantDraftApp | GeneralGrantDraftApp
): x is ProjectGrantDraftApp => x.form.type === 'PROJECT_GRANT'
const isGeneralGrantApp = (
  x: ProjectGrantDraftApp | GeneralGrantDraftApp
): x is GeneralGrantDraftApp => x.form.type === 'GENERAL_GRANT'

const maybeProjectGrantApp = (
  x: ProjectGrantDraftApp | GeneralGrantDraftApp
): O.Option<ProjectGrantDraftApp> => pipe(x, O.fromPredicate(isProjectGrantApp))

const maybeGeneralGrantApp = (
  x: ProjectGrantDraftApp | GeneralGrantDraftApp
): O.Option<GeneralGrantDraftApp> => pipe(x, O.fromPredicate(isGeneralGrantApp))
